import { render, staticRenderFns } from "./IconSearchArrowLeft.vue?vue&type=template&id=2bebc512&"
import script from "./IconSearchArrowLeft.vue?vue&type=script&lang=js&"
export * from "./IconSearchArrowLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bebc512')) {
      api.createRecord('2bebc512', component.options)
    } else {
      api.reload('2bebc512', component.options)
    }
    module.hot.accept("./IconSearchArrowLeft.vue?vue&type=template&id=2bebc512&", function () {
      api.rerender('2bebc512', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSearchArrowLeft.vue"
export default component.exports